import { Logger } from '@aws-lambda-powertools/logger'
import { injectLambdaContext } from '@aws-lambda-powertools/logger/middleware'
import { InjectLambdaContextOptions, LogLevel } from '@aws-lambda-powertools/logger/types'
import errorLogger from '@middy/error-logger'
import { HashnodeLogFormatter } from './log-formatter'

const ENVIRONMENT = process.env.ENVIRONMENT_NAME
const defaultLogLevel = ENVIRONMENT === 'prod' ? 'INFO' : 'DEBUG'
const logLevel = (process.env.LOG_LEVEL as LogLevel | undefined) ?? defaultLogLevel

export const logger = new Logger({
	sampleRateValue: 0.01,
	environment: ENVIRONMENT,
	logLevel,
	logFormatter: new HashnodeLogFormatter(),
})

export const injectLambdaContextToLogger = (
	logger: Logger,
	options?: Omit<InjectLambdaContextOptions, 'clearState'> | undefined,
) => {
	return [
		injectLambdaContext(logger, { clearState: true, ...options }),
		errorLogger({
			logger: (error) =>
				logger.error('Error logged by error-logger', {
					error,
				}),
		}),
	]
}

export type {
	Environment,
	LogAttributes,
	LogAttributesWithMessage,
	LogAttributeValue,
	LogLevel,
	LogLevelThresholds,
} from '@aws-lambda-powertools/logger/types'
